// Mock data for DMARKETINGCHAMP website

export const heroData = {
  title: "Grow, Sell & Scale Your Business Online",
  subtitle: "...Your Network, Your Future",
  description: "We help business owners, authors, and e-commerce brands build powerful digital presence, generate qualified leads, and achieve measurable growth through strategic digital marketing.",
  ctaPrimary: "Book a Free Strategy Call",
  ctaSecondary: "Chat on WhatsApp",
  heroImage: "https://images.unsplash.com/flagged/photo-1556514767-5c270b96a005"
};

export const services = [
  {
    id: 1,
    title: "Digital Marketing Strategy",
    description: "Comprehensive marketing strategies tailored to your business goals, target audience, and industry dynamics for maximum ROI.",
    icon: "target"
  },
  {
    id: 2,
    title: "Social Media Marketing",
    description: "Build engaged communities and drive conversions across Facebook, Instagram, LinkedIn, and Twitter with data-driven campaigns.",
    icon: "share-2"
  },
  {
    id: 3,
    title: "Paid Advertising (PPC)",
    description: "Strategic paid campaigns on Google Ads, Facebook Ads, and LinkedIn Ads to generate quality leads and maximize your ad spend.",
    icon: "trending-up"
  },
  {
    id: 4,
    title: "Search Engine Optimization",
    description: "Improve your organic visibility and rank higher on search engines with technical SEO, content optimization, and link building.",
    icon: "search"
  },
  {
    id: 5,
    title: "Website & Funnel Optimization",
    description: "Convert more visitors into customers with optimized websites, landing pages, and sales funnels designed for performance.",
    icon: "layout"
  },
  {
    id: 6,
    title: "Brand Promotion & Growth",
    description: "Amplify your brand presence, increase awareness, and establish authority in your industry through strategic promotion.",
    icon: "award"
  },
  {
    id: 7,
    title: "Ebook & Book Promotion",
    description: "Launch and promote your ebook or book with targeted campaigns, author brand building, and strategic marketing to reach your ideal readers.",
    icon: "book-open"
  },
  {
    id: 8,
    title: "Shopify Development & Marketing",
    description: "Build, optimize, and market your Shopify store with expert development, conversion optimization, and growth-focused marketing campaigns.",
    icon: "shopping-cart"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Proven Results",
    description: "We've helped hundreds of businesses achieve 3x-10x growth in revenue and online visibility.",
    icon: "check-circle"
  },
  {
    id: 2,
    title: "Tailored Strategies",
    description: "No cookie-cutter solutions. Every strategy is customized to your unique business needs and goals.",
    icon: "users"
  },
  {
    id: 3,
    title: "Professional Excellence",
    description: "Our team of certified digital marketing experts brings years of experience and industry best practices.",
    icon: "star"
  },
  {
    id: 4,
    title: "Data-Driven Approach",
    description: "Every decision is backed by analytics, testing, and measurable KPIs to ensure maximum ROI.",
    icon: "bar-chart"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "E-commerce Store Owner",
    company: "Fashion Boutique Online",
    content: "DMARKETINGCHAMP transformed our online presence! Our sales increased by 250% in just 6 months. Their Facebook Ads strategy brought us highly qualified leads that actually convert.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Author & Speaker",
    company: "Personal Brand",
    content: "Working with DMARKETINGCHAMP was a game-changer. They helped me build my author brand from scratch, and now I have a thriving community of 50,000+ followers. My book sales tripled!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e"
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "CEO",
    company: "Tech Solutions Ltd",
    content: "The SEO strategies implemented by DMARKETINGCHAMP took us from page 5 to page 1 on Google. Our organic traffic increased by 400%, and we're now closing more deals than ever.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
  },
  {
    id: 4,
    name: "David Williams",
    role: "Business Owner",
    company: "Local Services Co",
    content: "Professional, results-driven, and always available. DMARKETINGCHAMP doesn't just promise results—they deliver. Our lead generation increased by 180% in the first quarter.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
  }
];

export const portfolioResults = [
  {
    id: 1,
    title: "E-commerce Fashion Brand",
    category: "E-commerce",
    challenge: "Low online visibility and declining sales",
    solution: "Implemented comprehensive digital marketing strategy including SEO, paid ads, and social media campaigns",
    results: [
      "250% increase in online sales",
      "180% growth in organic traffic",
      "4.5x ROI on ad spend"
    ],
    image: "https://images.unsplash.com/photo-1730382624709-81e52dd294d4",
    duration: "6 months"
  },
  {
    id: 2,
    title: "Author Personal Brand",
    category: "Personal Brand",
    challenge: "Building authority and reaching target readers",
    solution: "Social media brand building, content marketing, and targeted Facebook campaigns",
    results: [
      "50,000+ engaged followers",
      "300% increase in book sales",
      "Established thought leadership"
    ],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
    duration: "8 months"
  },
  {
    id: 3,
    title: "B2B Tech Company",
    category: "B2B Services",
    challenge: "Low search engine rankings and minimal lead generation",
    solution: "Technical SEO overhaul, content strategy, and LinkedIn B2B campaigns",
    results: [
      "Page 1 Google rankings for 25+ keywords",
      "400% increase in organic leads",
      "65% reduction in cost per lead"
    ],
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf",
    duration: "10 months"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "10 Digital Marketing Strategies Every Business Owner Must Know in 2025",
    excerpt: "Discover the latest digital marketing trends and strategies that are driving results for businesses worldwide. From AI-powered campaigns to voice search optimization...",
    category: "Strategy",
    author: "DMARKETINGCHAMP Team",
    date: "2025-01-15",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1696041754237-e0c1ffd10138",
    slug: "10-digital-marketing-strategies-2025"
  },
  {
    id: 2,
    title: "How to Build a High-Converting Sales Funnel for Your E-commerce Store",
    excerpt: "Learn the step-by-step process to create sales funnels that convert visitors into paying customers. We break down the psychology, design, and automation...",
    category: "E-commerce",
    author: "DMARKETINGCHAMP Team",
    date: "2025-01-10",
    readTime: "12 min read",
    image: "https://images.pexels.com/photos/5716001/pexels-photo-5716001.jpeg",
    slug: "high-converting-sales-funnel-ecommerce"
  },
  {
    id: 3,
    title: "Social Media Marketing: The Complete Guide to Growing Your Brand",
    excerpt: "Master social media marketing with our comprehensive guide. From content creation to paid advertising, learn how to build an engaged community...",
    category: "Social Media",
    author: "DMARKETINGCHAMP Team",
    date: "2025-01-05",
    readTime: "15 min read",
    image: "https://images.pexels.com/photos/5716032/pexels-photo-5716032.jpeg",
    slug: "social-media-marketing-complete-guide"
  },
  {
    id: 4,
    title: "SEO in 2025: What's Changed and How to Adapt Your Strategy",
    excerpt: "Stay ahead of the curve with the latest SEO updates. Google's algorithm changes, AI search, and new ranking factors you need to know...",
    category: "SEO",
    author: "DMARKETINGCHAMP Team",
    date: "2024-12-28",
    readTime: "10 min read",
    image: "https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg",
    slug: "seo-2025-strategy-updates"
  },
  {
    id: 5,
    title: "The Author's Guide to Building a Profitable Online Presence",
    excerpt: "Transform your author platform into a revenue-generating machine. Learn how to leverage social media, email marketing, and content strategy...",
    category: "Personal Brand",
    author: "DMARKETINGCHAMP Team",
    date: "2024-12-20",
    readTime: "11 min read",
    image: "https://images.unsplash.com/photo-1543286386-2e659306cd6c",
    slug: "author-guide-online-presence"
  },
  {
    id: 6,
    title: "Paid Advertising ROI: How to Get More Bang for Your Buck",
    excerpt: "Maximize your advertising budget with proven strategies for Google Ads, Facebook Ads, and LinkedIn campaigns. Learn targeting, bidding, and optimization...",
    category: "Paid Ads",
    author: "DMARKETINGCHAMP Team",
    date: "2024-12-15",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1762968280286-0bfcc4afd0ea",
    slug: "paid-advertising-roi-strategies"
  }
];

export const aboutData = {
  title: "Your Trusted Digital Marketing Partner",
  subtitle: "Building Networks, Securing Futures",
  description: "DMARKETINGCHAMP is a results-driven digital marketing agency dedicated to helping businesses thrive in the digital landscape. We combine strategic thinking, creative execution, and data-driven insights to deliver measurable growth for our clients.",
  mission: "To empower businesses with cutting-edge digital marketing strategies that drive real, sustainable growth and establish lasting market presence.",
  vision: "To become the most trusted digital marketing partner for ambitious businesses looking to scale their online presence and revenue.",
  values: [
    {
      title: "Results-Focused",
      description: "Every strategy we create is designed to deliver measurable outcomes and ROI."
    },
    {
      title: "Client Success",
      description: "Your success is our success. We're committed to being true partners in your growth journey."
    },
    {
      title: "Innovation",
      description: "We stay ahead of digital trends to give our clients a competitive advantage."
    },
    {
      title: "Transparency",
      description: "Clear communication, honest reporting, and no hidden surprises."
    }
  ],
  team: {
    size: "15+",
    experience: "10+ years",
    clients: "200+",
    industries: "25+"
  },
  image: "https://images.unsplash.com/photo-1557804506-669a67965ba0"
};

export const contactInfo = {
  email: "Dmarketingchamp@gmail.com",
  whatsapp: "https://wa.me/18254514794",
  whatsappDisplay: "+1 825 451 4794",
  address: "Digital Marketing World",
  tagline: "...Your Network, Your Future"
};

export const socialMedia = {
  instagram: "https://www.instagram.com/dmarketingchamp",
  linkedin: "https://www.linkedin.com/in/dmarketingchamp/",
  twitter: "https://x.com/iamchampboss",
  facebook: "https://www.facebook.com/share/1C2yUiURH7/?mibextid=wwXIfr"
};

export const stats = [
  { label: "Happy Clients", value: "200+", icon: "users" },
  { label: "Successful Projects", value: "500+", icon: "briefcase" },
  { label: "Years Experience", value: "10+", icon: "clock" },
  { label: "Team Members", value: "15+", icon: "award" }
];
